import { createContext } from 'react';
import EditFranchiseContext from 'types/contexts/EditFranchiseContext';

export default createContext({} as EditFranchiseContext);
